import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../context/AuthContext';

import { getCountryCodes as getCountryCodesApi } from '../../services/apiCountryCodes'
import { useError } from '../../context/ErrorContext';

type countryCodesType = string[];

export function useCountryCodes() {
  const { handleErrorAction } = useError();
  const { user } = useAuth();
  const isAuthenticated = user?.isAuthenticated
  const { data: countryCodes, isLoading } = useQuery({
    queryKey: ["countryCodes"],
    queryFn: async () => {
      const { data } = await getCountryCodesApi()
      return data as countryCodesType
    },
    enabled: !!isAuthenticated,
    onError: (error: Error) => {
      handleErrorAction(error)
    }
  });

  return { countryCodes, isLoading };
}